import React from "react";
import { Link } from "react-router-dom";

/**
 * LegalShell — shared chrome for Privacy, Terms, and any future legal pages.
 * Matches the tome-card aesthetic of the rest of the app.
 */
export default function LegalShell({ title, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen bg-stone-950 text-stone-200" data-testid={testid}>
      <header className="border-b border-amber-500/20 bg-stone-950/80 backdrop-blur-md sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3 flex-wrap">
          <Link to="/" className="font-serif-display text-xl gold tracking-wide">
            Mythicmatrix
          </Link>
          <nav className="font-mono text-[0.6rem] sm:text-[0.65rem] uppercase tracking-[0.15em] sm:tracking-[0.3em] text-stone-400 flex gap-1 sm:gap-5 [&>a]:py-3 [&>a]:px-1.5">
            <Link to="/privacy" className="hover:gold transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:gold transition-colors">Terms</Link>
            <Link to="/founders" className="hover:gold transition-colors">Founders</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-6 py-8 sm:py-12 break-words">
        <div className="font-mono text-[0.6rem] uppercase tracking-[0.4em] gold mb-2">Covenant</div>
        <h1 className="font-serif-display text-3xl sm:text-5xl leading-tight mb-2">{title}</h1>
        {lastUpdated && (
          <p className="font-mono text-[0.65rem] uppercase tracking-widest text-stone-500 mb-10">
            Last updated · {lastUpdated}
          </p>
        )}
        <article className="font-prose text-stone-300 leading-relaxed space-y-8 text-[0.95rem]">
          {children}
        </article>
        <footer className="mt-16 pt-6 border-t border-amber-500/10 font-mono text-[0.6rem] uppercase tracking-[0.3em] text-stone-500 flex items-center justify-between flex-wrap gap-2">
          <Link to="/" className="hover:gold transition-colors">← Return to the Vault</Link>
          <span>Mythicmatrix · MMXXVI</span>
        </footer>
      </main>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-serif-display text-xl gold mb-3 leading-tight">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

export function LegalList({ children }) {
  return <ul className="space-y-2 pl-5 list-disc marker:text-amber-500/60">{children}</ul>;
}
